import { CompanyComponent } from "@/features";

export const CompanyPage = () => {
  return <CompanyComponent />;
}